// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://scluxxccawjbmeelfdwr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNjbHV4eGNjYXdqYm1lZWxmZHdyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk5ODM5MTYsImV4cCI6MjA4NTU1OTkxNn0.6WwkiUEwU2souO9qn0ozk17k_69TctxPsS9RCEDj_ZE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// TEMPORARY: Using 'any' for Database type until types are regenerated to match actual schema
// The current types.ts doesn't include all tables/columns that exist in the database
export const supabase = createClient<any>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});